import { ListViewGroup, ListViewRow, Stack, Text } from '@ekhodealer/ekho-common/rev';

import type { RequiredVehicleAccessory } from '@ekhodealer/ekho-common';

import { EmptySection } from '@common/components/EmptySection';

import { AccessoryLineItem } from './AccessoryLineItem';

interface SpecsListViewProps {
	specs: Array<RequiredVehicleAccessory>;
	/** Optional title to show above the list. Defaults to 'Specs' */
	title?: string;
	/** Optional empty message. Defaults to 'No specs available' */
	emptyMessage?: string;
}

/**
 * Reusable component for displaying a list of vehicle specs
 * Used across orders and leads features
 */
export const SpecsListView = ({
	specs,
	title = 'Specs',
	emptyMessage = 'No specs available',
}: SpecsListViewProps) => {
	return (
		<>
			<Text size='footnote' weight='semibold'>
				{title}
			</Text>
			<ListViewGroup>
				{specs && specs.length > 0 ? (
					specs.map((spec, index: number) => (
						<ListViewRow
							key={index}
							bottomContent={<AccessoryLineItem accessory={spec} />}
						/>
					))
				) : (
					<Stack>
						<EmptySection message={emptyMessage} />
					</Stack>
				)}
			</ListViewGroup>
		</>
	);
};
